"use client";

import clsx from "clsx";
import { useRef } from "react";
import * as Flex from "@repo/ui/flex";
import { useNavigation, useLogoInteraction } from "./hooks";
import LogosComponent from "./logos-component/logos-component";
import VideoOverlay from "./video-overlay";
import styles from "./logo-overlay.module.css";

type Section = "topshop" | "topman";

export default function VideoLogoOverlay({
  activeFloor,
}: {
  activeFloor: Section;
}) {
  const { navigateToSection } = useNavigation();
  const { state, setHovered, setVideoFinished, handleSectionClick } =
    useLogoInteraction();

  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleClick = (target: Section) => {
    handleSectionClick(target, navigateToSection);
  };

  return (
    <Flex.Container
      column
      justify="center"
      align="center"
      className={clsx(styles["landing-container"], styles[activeFloor])}
    >
      {!activeFloor && (
        <VideoOverlay
          onFinish={() => setVideoFinished(true)}
          videoFinished={state.videoFinished}
        />
      )}
      <LogosComponent
        clicked={state.clicked}
        hovered={state.hovered}
        handleClick={handleClick}
        setHovered={setHovered}
        isNavigating={state.isNavigating}
        containerRef={containerRef}
      />
    </Flex.Container>
  );
}
